import React from "react";
import PortalSidebar from "@/components/PortalSidebar";
import { Outlet } from "react-router-dom";
import SIXChat from "@/components/SIXChat";

export default function PortalShell({ role }) {
  // Ops face for admin; copilot for client/partner; buyer has no dedicated face in Phase 3
  const face = role === "admin" ? "ops" : (role === "buyer" ? null : "copilot");
  return (
    <div className="min-h-screen flex" style={{ background: "var(--dt6-bg)" }}>
      <PortalSidebar role={role} />
      <main className="flex-1 overflow-auto" data-testid="portal-main">
        <Outlet />
      </main>
      {face && <SIXChat face={face} variant="floating" />}
    </div>
  );
}
